<template>
  <div class="mt-2 flex flex-col space-y-2">
    <div class="border-slate-150 rounded-lg border px-2">
      <span class="text-gray-700">Titulo: </span><span>{{ notificacion.titulo }}</span>
    </div>
    <div class="border-slate-150 rounded-lg border px-2">
      <span class="text-gray-700">Para: </span><span>{{ notificacion.para?.replace(/,/g, ', ') }}</span>
    </div>
    <div class="border-slate-150 rounded-lg border px-2">
      <span class="text-gray-700">CC: </span><span class="break-words">{{ notificacion.cc?.replace(/,/g, ', ') }}</span>
    </div>
    <div class="border-slate-150 rounded-lg border px-2" v-html="notificacion.cuerpo"></div>
  </div>
</template>
<script>
export default {
  name: 'VistaGmail',
  props: {
    notificacion: { type: Object, required: true, default: null },
  },
}
</script>
